<template>
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.29924 6.90234L5.18326 10.2047C4.91614 10.4765 4.48367 10.4761 4.217 10.2032C3.95053 9.93047 3.95122 9.48859 4.21837 9.21652L6.84906 6.40836L4.21837 3.6911C3.95125 3.419 3.95057 2.9774 4.217 2.70459C4.35068 2.56783 4.52581 2.49945 4.70094 2.49945C4.87562 2.49945 5.05006 2.56737 5.1835 2.70318L8.29924 5.91442C8.42789 6.04513 8.50009 6.22302 8.50009 6.40836C8.50009 6.59371 8.42769 6.77138 8.29924 6.90234Z" fill="#9AA3B0"/></svg>
</template>

<script>
export default {
}
</script>